/** Anything a `cond && 'class'` expression can evaluate to. */
type ClassValue = string | number | bigint | boolean | null | undefined;

/**
 * Joins class names, dropping anything that isn't a non-empty string.
 *
 * The codebase builds conditional classes with template literals
 * (`` `pill${active ? ' pill--active' : ''}` ``), which reads badly once there
 * is more than one condition. This is the same idea as `clsx` but small enough
 * not to be worth a dependency.
 *
 * Non-string values are dropped rather than stringified, so a guard like
 * `count && 'has-items'` contributes nothing instead of emitting a `0` class.
 */
export function cx(...parts: ClassValue[]): string {
  return parts.filter((part): part is string => typeof part === 'string' && part !== '').join(' ');
}
